import { Controller, useFormContext } from "react-hook-form";

import type { TextInputProps } from "@luna-restaurant/ui";
import { TextInput } from "@luna-restaurant/ui";

export type FormTextInputProps = {
  name: string;
  label: string;
  type?: TextInputProps["type"];
} & Omit<TextInputProps, "placeholder" | "type" | "value">;

export function FormTextInput({
  name,
  label,
  type = "text",
  ...inputProps
}: FormTextInputProps) {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, onBlur, value }, fieldState }) => (
        <TextInput
          value={value}
          placeholder={label}
          type={type}
          onChangeText={onChange}
          onBlur={onBlur}
          error={fieldState.error?.message ?? false}
          {...inputProps}
        />
      )}
    />
  );
}
